// First party consent store, shared with the website: one choice for every
// improve.online site (plan 3.4). It records { analytics, marketing } in a
// cookie on .improve.online under a name per environment
// (VUE_APP_CONSENT_COOKIE: improve_consent_v2 on production,
// improve_consent_v2_stg on staging), so a choice made on the website applies
// here and the other way round. KEEP IN STEP with improve-online
// src/utils/consent.js: same name, same domain, same format.
//
// The app uses `analytics` (utils/analytics.js); `marketing` covers the
// website's YouTube and Synthesia videos.
//
// Plan: docs/plans/analytics-newco-replacement-2026-10.md in the tracker repo.

const COOKIE_NAME = process.env.VUE_APP_CONSENT_COOKIE || "improve_consent_v2";
const SHARED_DOMAIN = "improve.online";
const MAX_AGE_DAYS = 180;

function onSharedDomain() {
  if (typeof location === "undefined") return false;
  const host = location.hostname;
  return host === SHARED_DOMAIN || host.endsWith("." + SHARED_DOMAIN);
}

function attributes(maxAgeSeconds) {
  const domain = onSharedDomain() ? "; domain=." + SHARED_DOMAIN : "";
  // Secure on HTTPS only: on plain http localhost it would stop the cookie
  // being stored at all.
  const secure =
    typeof location !== "undefined" && location.protocol === "https:" ? "; Secure" : "";
  return "; max-age=" + maxAgeSeconds + "; path=/; SameSite=Lax" + domain + secure;
}

function read() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"));
  if (!match) return null;
  try {
    const obj = JSON.parse(decodeURIComponent(match[1]));
    return obj && typeof obj === "object" ? obj : null;
  } catch (e) {
    return null;
  }
}

export function getConsent() {
  return read();
}

// True once the visitor has made any choice, here or on the website.
export function hasResponded() {
  return read() !== null;
}

export function hasAnalytics() {
  const c = read();
  return !!(c && c.analytics);
}

export function setConsent({ analytics = false, marketing = false } = {}) {
  const value = JSON.stringify({ analytics: !!analytics, marketing: !!marketing, ts: Date.now() });
  document.cookie =
    COOKIE_NAME + "=" + encodeURIComponent(value) + attributes(MAX_AGE_DAYS * 24 * 60 * 60);
}
